import { ApiResult, HttpClient } from "../http.js";
import {
  KlsInspectionDto,
  KlsInspectionStatus,
} from "../types/kls-inspections.js";

export interface KlsInspectionResponsePayload {
  itemId: string;
  question: string;
  type: string;
  /** Polymorphic value — boolean | string | number | null. */
  value?: unknown;
  photoUrl?: string | null;
  notes?: string | null;
}

export interface CreateKlsInspectionPayload {
  checklistId: string;
  checklistName: string;
  checklistType: string;
  projectId?: string | null;
  projectTitle?: string | null;
  assignmentId?: string | null;
  assignmentTitle?: string | null;
  inspectorId: string;
  inspectorName: string;
  status: KlsInspectionStatus;
  responses?: KlsInspectionResponsePayload[] | null;
  photos?: string[] | null;
  signature?: string | null;
  notes?: string | null;
  location?: string | null;
  address?: string | null;
  completedAt?: string | null;
  approvedById?: string | null;
  approvedByName?: string | null;
  approvedAt?: string | null;
  rejectionReason?: string | null;
  id?: string;
}

export interface UpdateKlsInspectionPayload {
  checklistId: string;
  checklistName: string;
  checklistType: string;
  projectId?: string | null;
  projectTitle?: string | null;
  assignmentId?: string | null;
  assignmentTitle?: string | null;
  inspectorId: string;
  inspectorName: string;
  status: KlsInspectionStatus;
  responses?: KlsInspectionResponsePayload[] | null;
  photos?: string[] | null;
  signature?: string | null;
  notes?: string | null;
  location?: string | null;
  address?: string | null;
  completedAt?: string | null;
  approvedById?: string | null;
  approvedByName?: string | null;
  approvedAt?: string | null;
  rejectionReason?: string | null;
}

export interface ListKlsInspectionsQuery {
  /** Filter to inspections on a specific project (Firestore projectId string). */
  projectId?: string;
  /** Filter to inspections by a specific inspector (Firestore inspectorId string). */
  inspectorId?: string;
}

export class KlsInspectionsApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListKlsInspectionsQuery = {}): Promise<ApiResult<KlsInspectionDto[]>> {
    return this.http.get<KlsInspectionDto[]>("/api/kls-inspections", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<KlsInspectionDto>> {
    return this.http.get<KlsInspectionDto>(`/api/kls-inspections/${encodeURIComponent(id)}`);
  }

  create(payload: CreateKlsInspectionPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/kls-inspections", { body: payload });
  }

  update(id: string, payload: UpdateKlsInspectionPayload): Promise<ApiResult<KlsInspectionDto>> {
    return this.http.put<KlsInspectionDto>(`/api/kls-inspections/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/kls-inspections/${encodeURIComponent(id)}`);
  }
}
